import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import { Grid, FormHelperText } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { searchSubmit } from "./model/search-actions";
import { store } from "../../../../helpers/store";
import { history } from "../../../../helpers/index";
import { routePaths } from "../../../config/route-paths";

const useStyles = makeStyles((theme) => ({
  root: {
    border: "1px solid lightgray",
    borderRadius: "5px",
    width: "100%",
    // height: "35px",
  },
  root1: {
    border: "1px solid lightgray",
    borderRadius: "5px",
    height: "35px",
  },
  error: {
    border: "1px solid red",
    borderRadius: "5px",
    width: "100%",
    height: "35px",
  },
  error1: {
    border: "1px solid red",
    borderRadius: "5px",
    height: "35px",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    minWidth: "200px",
  },
  iconButton: {
    padding: 10,
  },
}));

export default function SearchBar(props) {
  const classes = useStyles();
  const smQuery = useMediaQuery({ query: "(min-width: 600px)" });
  const [keyword, setKeyword] = useState("");
  const [error, setError] = useState(false);
  const labels = useSelector((state) => state?.labels?.data?.getLabels?.SEARCH);

  const dispatch = useDispatch();

  const handleSearchInputChange = (e) => {
    setError(false)
    setKeyword(e.target.value.trim());
  };

  const searchClickHandle = (e) => {
    e.preventDefault();
    let word = keyword?.split("");
    if (word?.length >= 3) {
      setError(false);
      dispatch(searchSubmit(keyword));
      history.push(routePaths.SEARCH_RESULTS+"?q="+keyword);
      store.getState().snackbar = true;
    } else {
      setError(true);
    }
  };

  const keyPress = (e) => {
    e.preventDefault();
    if (e.key === "Enter") {
      searchClickHandle();
    }
  };

  return (
    <form onSubmit={searchClickHandle}>
      <Grid
        container
        justify="space-between"
        alignContent="center"
        alignItems="center"
        className={
          smQuery
            ? error
              ? classes.error
              : classes.root
            : error
            ? classes.error1
            : classes.root1
        }
      >
        <InputBase
          onChange={(e) => handleSearchInputChange(e)}
          className={classes.input}
          placeholder={labels?.SEARCH_PLACEHOLDER}
          inputProps={{ "aria-label": labels?.SEARCH_PLACEHOLDER }}
        />
        <IconButton
          type="submit"
          className={classes.iconButton}
          aria-label="search"
          onClick={searchClickHandle}
          onKeyPress={keyPress}
        >
          <SearchIcon />
        </IconButton>
      </Grid>
      {error ? (
        <FormHelperText style={{ color: "red" }}>
          {labels?.SEARCH_WARNING}
        </FormHelperText>
      ) : null}
    </form>
  );
}
